import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import bestD1 from "../assests/bestD1.png";
import bestD2 from "../assests/bestD2.png";
import bestD3 from "../assests/bestD3.png";

const BestDeals = () => {

  return (
    <>
      <Box sx={{ padding: "120px 0", background: "#fff" }}>
        <Container maxWidth="xl">
          <Grid
            container
            spacing={10}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <Grid item xs={12} sm={12} md={4} lg={4} sx={{ width: "45%" }}>
              {/* <Typography
                sx={{
                  fontFamily: `"Quicksand", sans-serif`,
                  fontWeight: 700,
                  lineHeight: "28.8px",
                  fontSize: "24px",
                  color: "#B6B6B6",
                  textAlign: "left",
                  margin: "0 0 20px",
                }}
              >
                Our best deals
              </Typography> */}
              <Typography
                sx={{
                  fontFamily: `"Quicksand", sans-serif`,
                  fontWeight: 700,
                  lineHeight: "57.6px",
                  fontSize: "48px",
                  color: "#253D4E",
                  textAlign: "left",
                  margin: "20px 0",
                }}
              >
                Mission
              </Typography>
              <Typography
                sx={{
                  fontFamily: `"Lato", sans-serif`,
                  fontWeight: 400,
                  lineHeight: "24px",
                  fontSize: "16px",
                  color: "#7E7E7E",
                  textAlign: "left",
                  margin: "20px 0",
                }}
              >
                At Lifeline, our mission is to empower healthcare systems by producing and supplying essential medical goods from Jordan with uncompromising quality, regulatory compliance, and efficiency. We reduce costs through optimized international trade structures and partnerships, enabling U.S. providers to deliver better care to patients while ensuring fair and sustainable opportunities for manufacturers abroad.
              </Typography>
              {/* <Typography
                sx={{
                  fontFamily: `"Lato", sans-serif`,
                  fontWeight: 400,
                  lineHeight: "24px",
                  fontSize: "16px",
                  color: "#7E7E7E",
                  textAlign: "left",
                }}
              >
                Ed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
                quae ab illo inventore veritatis et quasi architecto
              </Typography> */}
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} sx={{ width: "45%" }}>
              {/* <Typography
                sx={{
                  fontFamily: `"Quicksand", sans-serif`,
                  fontWeight: 700,
                  lineHeight: "28.8px",
                  fontSize: "24px",
                  color: "#B6B6B6",
                  textAlign: "left",
                  margin: "0 0 20px",
                }}
              >
                Our best deals
              </Typography> */}
              <Typography
                sx={{
                  fontFamily: `"Quicksand", sans-serif`,
                  fontWeight: 700,
                  lineHeight: "57.6px",
                  fontSize: "48px",
                  color: "#253D4E",
                  textAlign: "left",
                  margin: "20px 0",
                }}
              >
                Vision
              </Typography>
              <Typography
                sx={{
                  fontFamily: `"Lato", sans-serif`,
                  fontWeight: 400,
                  lineHeight: "24px",
                  fontSize: "16px",
                  color: "#7E7E7E",
                  textAlign: "left",
                  margin: "20px 0",
                }}
              >
                We envision a world where medical supply chains are secure, transparent, and resilient. By uniting the innovation of Jordanian production with the needs of the U.S. healthcare market, Lifeline strives to set a new standard for trust, affordability, and quality in global medical supply. Our goal is to create a model of cross-border collaboration that serves both healthcare providers and the patients who depend on them.
              </Typography>
              {/* <Typography
                sx={{
                  fontFamily: `"Lato", sans-serif`,
                  fontWeight: 400,
                  lineHeight: "24px",
                  fontSize: "16px",
                  color: "#7E7E7E",
                  textAlign: "left",
                }}
              >
                Ed ut perspiciatis unde omnis iste natus error sit voluptatem
                accusantium doloremque laudantium, totam rem aperiam, eaque ipsa
                quae ab illo inventore veritatis et quasi architecto
              </Typography> */}
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default BestDeals;
